<app-main-table
  [apiService]="apiRoleService"
  [columns]="columns"
  [pluralEntityName]="'roles'"
  [additionalMainActions]="additionalMainActions"
  (onMainAction)="mainActions($event)"
></app-main-table>
<!--Form to create or update a admin-->
<p-dialog [(visible)]="createEntity" [style]="{ width: '450px' }" [header]="roleService.formMethod === 'CREATE' ? 'Nuevo role' : 'Actualizar role'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-admin-role-form></app-admin-role-form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="saveForm()" [disabled]="!roleService.entity.valid"></button>
  </ng-template>
</p-dialog>
